<template>
  <!--
    Komponent wyświetlający wybrane lokalizacje jako aktywne filtry.
    Renderowany tylko, gdy istnieje co najmniej jedna wybrana lokalizacja w store.selectedLocation.
  -->
  <div v-if="store.selectedLocation.length" class="filter d-flex flex-column">
    <!--
      Nagłówek sekcji:
      - t('station'): przetłumaczony klucz stacji, wyświetlany wielkimi literami
    -->
    <h2 class="margin-0">{{ t('station').toUpperCase() }}</h2>

    <!--
      Iteracja po każdej wybranej lokalizacji z store.selectedLocation
      Każda lokalizacja wyświetlana z nazwą i możliwością usunięcia filtra
    -->
    <div v-for="location in store.selectedLocation" :key="location.id">
      <h5 class="margin-0">
        <!-- Nazwa lokalizacji -->
        {{ location.name }}
        <!--
          Ikona kosza: po kliknięciu usuwa konkretną lokalizację z filtrów
          Używamy metody setFilter przekazując id lokalizacji
        -->
        <span
          class="icon-trash"
          @click="setFilter(location.id)"
          role="button"
        ></span>
      </h5>

      <!--
        Dodatkowe informacje o stacji:
        - roadNumber i chainage: numer drogi i pozycja
        - direction: kierunek ruchu
      -->
      <div class="info collapse show" :id="location.id">
        <p class="margin-0">
          {{ t('road-no') }}: {{ location.roadNumber }} / {{ location.chainage }}
        </p>
        <p class="margin-0">
          {{ t('direction') }}: {{ location.direction }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LocationsFilterView", // Nazwa komponentu dla Vue DevTools

  props: {
    // Store Pinia przechowujący wybrane lokalizacje i metody ich modyfikacji
    store: { required: true },
  },

  methods: {
    /**
     * Przełącza filtr lokalizacji:
     * - Dodaje lub usuwa lokalizację o podanym id z listy store.selectedLocation
     * @param {number|string} id - unikalny identyfikator lokalizacji
     */
    setFilter(id) {
      this.store.addItem("LocationList", id);
    },
  },
};
</script>

<style scoped>
/*
  Główny kontener filtra:
  - szeroki, układ kolumnowy flex
*/
.filter {
  width: 100%;
}

/*
  Nagłówek (h2) sekcji:
  - padding i border-bottom dla oddzielenia
*/
.filter h2 {
  padding: var(--spacing-md) var(--spacing-lg);
  width: 100%;
  border-bottom: 1px solid var(--border-default);
  margin: 0;
}

/*
  Nagłówki poszczególnych lokalizacji (h5):
  - tło z grafiką, padding, pozycjonowanie relative
*/
.filter h5 {
  margin: 0;
  padding: var(--spacing-md) var(--spacing-lg);
  position: relative;
  background: var(--surface-secondary);
  border-bottom: 1px solid var(--border-default);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-bold);
  letter-spacing: var(--letter-spacing-caps);
  text-transform: uppercase;
  color: var(--text-primary);
}

/*
  Wiersz informacji (div.info):
  - font-size, padding, border-bottom do oddzielenia elementów
*/
.info {
  font-size: var(--font-size-sm);
  padding: var(--spacing-md) var(--spacing-lg);
  border-bottom: 1px solid var(--border-default);
}

/*
  Aktywny element <p> wewnątrz .info:
  - margin: 0, font-size
*/
.info p {
  font-size: var(--font-size-sm);
  margin: 0;
}

/*
  Ikona kosza:
  - pozycjonowanie w prawym górnym rogu elementu h5
*/
.icon-trash {
  background: url("../../assets/icons/trash.svg") no-repeat left top;
  width: 15px;
  height: 17px;
  position: absolute;
  cursor: pointer;
  top: 13px;
  right: 10px;
}
</style>